import React, { useEffect, useState } from 'react'
import './OriginalMessagePage.scoped.sass'
import modalService from '@/services/modal.service'
import { ReactComponent as CloseIcon } from '@/assets/icons/close-icon.svg'
import ToastService from '@/components/Toast/Toast.service'
import messagesService from '@/app-domains/messages/messages.service'
import { LoadingSpinner } from '../../components/LoadingSpinner/index.jsx'

const OriginalMessagePage = (props) => {
  const { message } = props
  const [originalMessage, setOriginalMessage] = useState('')
  const [isOriginalMessageLoading, setIsOriginalMessageLoading] = useState(false)

  useEffect(() => {
    setIsOriginalMessageLoading(true)
    downloadOriginal(message.messageid)
  }, [])

  /* function getSPF () {
    if (!message.headers) {
      return '-'
    } else {
      return '-'
    }
  }

  function getDKIM () {
    if (!message.headers) {
      return '-'
    } else {
      return '-'
    }
  }

  function getDMARC () {
    if (!message.headers) {
      return '-'
    } else {
      return '-'
    }
  } */

  function copyToClipboard () {
    const copyText = message.html

    navigator.clipboard.writeText(copyText)

    ToastService.show({
      title: 'Message copied!',
      message: 'Your message was copied succesfully!',
      type: 'success'
    })
  }
  
  async function downloadOriginal () {
    try {
      const originalMessage = await messagesService.getOriginalMessage(message.messageid)
      setOriginalMessage(originalMessage)
    } catch (error) {
      setIsOriginalMessageLoading(false)
      setOriginalMessage(undefined)
    }
  }

  function getOriginalMessage () {
    if (!originalMessage && isOriginalMessageLoading === true) {
      return (
        <div>
          <LoadingSpinner />
        </div>
      )
    } else if (originalMessage) {
      return (
        originalMessage?.rawMessage?.data.split(/(?:\r\n|\r|\n)/g).map((str, index) => <p key={index}>{str}</p>)
      )
    } else if (!originalMessage && isOriginalMessageLoading === false) {
      return (
        <p className='error-message'>
          Oh no! It seems that there is a problem showing the original message!
        </p>
      )
    }
  }

  return (
    <div className='main-container'>
      <div className='page'>
        <div className='top-header'>
          <span className='header-text'>
            Original Message
          </span>
          <div className='close-button' onClick={() => { modalService.close() }}>
            <CloseIcon />
          </div>
        </div>
        <div className='top-part'>
          <div className='info-div message-id-div'>
            <div className='title message-id'>Message ID</div>
            <div className='info message-id'>{message.messageid}</div>
          </div>
          <div className='info-div created-at-div'>
            <div className='title created-at'>Created at</div>
            <div className='info created-at'>{message.date}</div>
          </div>
          <div className='info-div from-div'>
            <div className='title from'>From</div>
            <div className='info from'>{message.fromEmail}</div>
          </div>
          <div className='info-div to-div'>
            <div className='title to'>To</div>
            <div className='info to'>{message.tos.map((to) => to)}</div>
          </div>
          <div className='info-div subject-div'>
            <div className='title subject'>Subject</div>
            <div className='info subject'>{message.subject}</div>
          </div>
          { /* <div className='info-div spf-div'>
            <div className='title spf'>SPF</div>
            <div className='info spf'>{getSPF()}</div>
          </div>
          <div className='info-div dkim-div'>
            <div className='title dkim'>DKIM</div>
            <div className='info dkim'>{getDKIM()}</div>
          </div>
          <div className='info-div dmarc-div'>
            <div className='title dmarc'>DMARC</div>
            <div className='info dmarc'>{getDMARC()}</div>
          </div> */
          }
          <div className='info-div more-div'>
            { /* <div className='title more' onClick={downloadOriginal}>Download Original</div> */ }
            <div className='info more' onClick={copyToClipboard}>Copy to clipboard</div>
          </div>
        </div>
        <div className='bottom-part'>
          <span className='original-message'>
            {getOriginalMessage()}
          </span>
        </div>
      </div>
    </div>
  )
}

export default OriginalMessagePage
